import { render, staticRenderFns } from "./CNAM.vue?vue&type=template&id=0bc74a72&scoped=true"
import script from "./CNAM.vue?vue&type=script&lang=js"
export * from "./CNAM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc74a72",
  null
  
)

export default component.exports